import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AttachProfileWithConnectEmailResponse
  extends BackendResponse {}

export interface AttachProfileWithConnectEmailParameters extends NextApiParams {
  concernId: number;
}

export const attachProfileWithConnectEmail = withNextApi<
  AttachProfileWithConnectEmailResponse,
  AttachProfileWithConnectEmailParameters
>("/auth/AttachProfileWithConnectEmail");
